/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Stats_Releases_HeadingInputs */

const id_stats_releases_heading = /** @type {(inputs: Stats_Releases_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Statistik rilis Epic Games Store`)
};

const ms_stats_releases_heading = /** @type {(inputs: Stats_Releases_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Statistik keluaran Epic Games Store`)
};

const da_stats_releases_heading = /** @type {(inputs: Stats_Releases_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Epic Games Store udgivelsesstatistik`)
};

const de_stats_releases_heading = /** @type {(inputs: Stats_Releases_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Epic Games Store Veröffentlichungsstatistiken`)
};

const en_us2_stats_releases_heading = /** @type {(inputs: Stats_Releases_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Epic Games Store release stats`)
};

const es_es2_stats_releases_heading = /** @type {(inputs: Stats_Releases_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Estadísticas de lanzamientos de la Epic Games Store`)
};

const es_mx2_stats_releases_heading = /** @type {(inputs: Stats_Releases_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Estadísticas de lanzamientos de la Epic Games Store`)
};

const fil_stats_releases_heading = /** @type {(inputs: Stats_Releases_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Estadistika ng release ng Epic Games Store`)
};

const fr_stats_releases_heading = /** @type {(inputs: Stats_Releases_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Statistiques de sorties de l'Epic Games Store`)
};

const it_stats_releases_heading = /** @type {(inputs: Stats_Releases_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Statistiche uscite Epic Games Store`)
};

const hu_stats_releases_heading = /** @type {(inputs: Stats_Releases_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Epic Games Store megjelenési statisztikák`)
};

const nl_stats_releases_heading = /** @type {(inputs: Stats_Releases_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Epic Games Store releasestatistieken`)
};

const no_stats_releases_heading = /** @type {(inputs: Stats_Releases_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Epic Games Store utgivelsesstatistikk`)
};

const pl_stats_releases_heading = /** @type {(inputs: Stats_Releases_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Statystyki wydań Epic Games Store`)
};

const pt_br2_stats_releases_heading = /** @type {(inputs: Stats_Releases_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Estatísticas de lançamento de Epic Games Store`)
};

const pt_stats_releases_heading = /** @type {(inputs: Stats_Releases_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Estatísticas de lançamentos da Epic Games Store`)
};

const ro_stats_releases_heading = /** @type {(inputs: Stats_Releases_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Statistici lansări Epic Games Store`)
};

const fi_stats_releases_heading = /** @type {(inputs: Stats_Releases_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Epic Games Storen julkaisutilastot`)
};

const sv_stats_releases_heading = /** @type {(inputs: Stats_Releases_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Epic Games Store släppstatistik`)
};

const vi_stats_releases_heading = /** @type {(inputs: Stats_Releases_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Thống kê phát hành Epic Games Store`)
};

const tr_stats_releases_heading = /** @type {(inputs: Stats_Releases_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Epic Games Store çıkış istatistikleri`)
};

const cs_stats_releases_heading = /** @type {(inputs: Stats_Releases_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Statistiky vydání Epic Games Store`)
};

const bg_stats_releases_heading = /** @type {(inputs: Stats_Releases_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Статистика на издаванията в Epic Games Store`)
};

const ru_stats_releases_heading = /** @type {(inputs: Stats_Releases_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Статистика релизов Epic Games Store`)
};

const uk_stats_releases_heading = /** @type {(inputs: Stats_Releases_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Статистика релізів Epic Games Store`)
};

const ar_stats_releases_heading = /** @type {(inputs: Stats_Releases_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`إحصائيات إصدارات Epic Games Store`)
};

const hi_stats_releases_heading = /** @type {(inputs: Stats_Releases_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Epic Games Store रिलीज़ आँकड़े`)
};

const th_stats_releases_heading = /** @type {(inputs: Stats_Releases_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`สถิติการวางจำหน่าย Epic Games Store`)
};

const ja_stats_releases_heading = /** @type {(inputs: Stats_Releases_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Epic Games Store リリース統計`)
};

const zh_cn2_stats_releases_heading = /** @type {(inputs: Stats_Releases_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Epic游戏商城发布统计`)
};

const zh_hant1_stats_releases_heading = /** @type {(inputs: Stats_Releases_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Epic遊戲商城發布統計`)
};

const ko_stats_releases_heading = /** @type {(inputs: Stats_Releases_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Epic Games Store 출시 통계`)
};

/**
* | output |
* | --- |
* | "Epic Games Store release stats" |
*
* @param {Stats_Releases_HeadingInputs} inputs
* @param {{ locale?: "id" | "ms" | "da" | "de" | "en-US" | "es-ES" | "es-MX" | "fil" | "fr" | "it" | "hu" | "nl" | "no" | "pl" | "pt-BR" | "pt" | "ro" | "fi" | "sv" | "vi" | "tr" | "cs" | "bg" | "ru" | "uk" | "ar" | "hi" | "th" | "ja" | "zh-CN" | "zh-Hant" | "ko" }} options
* @returns {LocalizedString}
*/
const stats_releases_heading = /** @type {((inputs?: Stats_Releases_HeadingInputs, options?: { locale?: "id" | "ms" | "da" | "de" | "en-US" | "es-ES" | "es-MX" | "fil" | "fr" | "it" | "hu" | "nl" | "no" | "pl" | "pt-BR" | "pt" | "ro" | "fi" | "sv" | "vi" | "tr" | "cs" | "bg" | "ru" | "uk" | "ar" | "hi" | "th" | "ja" | "zh-CN" | "zh-Hant" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Stats_Releases_HeadingInputs, { locale?: "id" | "ms" | "da" | "de" | "en-US" | "es-ES" | "es-MX" | "fil" | "fr" | "it" | "hu" | "nl" | "no" | "pl" | "pt-BR" | "pt" | "ro" | "fi" | "sv" | "vi" | "tr" | "cs" | "bg" | "ru" | "uk" | "ar" | "hi" | "th" | "ja" | "zh-CN" | "zh-Hant" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_stats_releases_heading(inputs)
	if (locale === "ms") return ms_stats_releases_heading(inputs)
	if (locale === "da") return da_stats_releases_heading(inputs)
	if (locale === "de") return de_stats_releases_heading(inputs)
	if (locale === "en-US") return en_us2_stats_releases_heading(inputs)
	if (locale === "es-ES") return es_es2_stats_releases_heading(inputs)
	if (locale === "es-MX") return es_mx2_stats_releases_heading(inputs)
	if (locale === "fil") return fil_stats_releases_heading(inputs)
	if (locale === "fr") return fr_stats_releases_heading(inputs)
	if (locale === "it") return it_stats_releases_heading(inputs)
	if (locale === "hu") return hu_stats_releases_heading(inputs)
	if (locale === "nl") return nl_stats_releases_heading(inputs)
	if (locale === "no") return no_stats_releases_heading(inputs)
	if (locale === "pl") return pl_stats_releases_heading(inputs)
	if (locale === "pt-BR") return pt_br2_stats_releases_heading(inputs)
	if (locale === "pt") return pt_stats_releases_heading(inputs)
	if (locale === "ro") return ro_stats_releases_heading(inputs)
	if (locale === "fi") return fi_stats_releases_heading(inputs)
	if (locale === "sv") return sv_stats_releases_heading(inputs)
	if (locale === "vi") return vi_stats_releases_heading(inputs)
	if (locale === "tr") return tr_stats_releases_heading(inputs)
	if (locale === "cs") return cs_stats_releases_heading(inputs)
	if (locale === "bg") return bg_stats_releases_heading(inputs)
	if (locale === "ru") return ru_stats_releases_heading(inputs)
	if (locale === "uk") return uk_stats_releases_heading(inputs)
	if (locale === "ar") return ar_stats_releases_heading(inputs)
	if (locale === "hi") return hi_stats_releases_heading(inputs)
	if (locale === "th") return th_stats_releases_heading(inputs)
	if (locale === "ja") return ja_stats_releases_heading(inputs)
	if (locale === "zh-CN") return zh_cn2_stats_releases_heading(inputs)
	if (locale === "zh-Hant") return zh_hant1_stats_releases_heading(inputs)
	return ko_stats_releases_heading(inputs)
});
export { stats_releases_heading as "stats.releases.heading" }